/**
 * Cómo se parte en páginas el bloque de una categoría cuando el editor pidió más notas de las que
 * entran de una vez. Es lógica de índices pura, y como la cadencia de avisos
 * (`shared/ads/cadencia.ts`) vive aparte y con test propio: es la más fácil de romper y la más
 * barata de cubrir.
 *
 * Las páginas son **estado local del componente**: todas las notas del bloque ya vinieron en la
 * respuesta de la home, así que pasar de página no le pide nada a la API, no cambia la URL y no
 * mueve el scroll (ojo con esto: el ítem 03 del backlog manda volver al tope al *cambiar de
 * página*, y esto no es cambiar de página).
 */
export function enPaginas<T>(items: T[], porPagina: number): T[][] {
  if (porPagina < 1) return [items];
  const total = Math.max(1, Math.ceil(items.length / porPagina));
  return Array.from({ length: total }, (_, i) => items.slice(i * porPagina, (i + 1) * porPagina));
}
